import { Stack } from '@src/shared/ui/layout';
import { PAGE_LAYOUT_SCROLL_CONTAINER_ID } from './constants';
import type { ReactNode } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <Stack
      id={PAGE_LAYOUT_SCROLL_CONTAINER_ID}
      useFlexGap
      spacing={1}
      sx={{ overflowY: 'auto' }}
    >
      <Header />
      <Stack direction="row" useFlexGap spacing={1.25} sx={{ height: '100%' }}>
        {children}
        <Sidebar />
      </Stack>
    </Stack>
  );
}
